// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"19bb0d78","977":"1398320b"}[chunkId] + ".chunk.js";
};